package org.lennycodes.hldi.styles

import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextDecorationLine
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.css.TransitionTimingFunction
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.bottom
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.display
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.left
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.textDecorationLine
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.selectors.hover
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.s
import org.lennycodes.hldi.constants.HLDITheme

val NavItemStyle = CssStyle {
    base {
        Modifier
            .display(DisplayStyle.Block)
            .position(Position.Relative)
            .border(0.px, LineStyle.None)
            .borderRadius(6.px)
            .color(HLDITheme.Colors.text)
            .textDecorationLine(TextDecorationLine.None)
            .fontSize(14.px)
            .padding(8.px, 12.px)

            .transition(
                Transition.all(
                    duration = 0.3.s,
                    timingFunction = TransitionTimingFunction.cubicBezier(0.4, 0.0, 0.2, 1.0)
                )
            )
    }

    hover {
        Modifier
            .color(HLDITheme.Colors.primary)
            .backgroundColor(HLDITheme.Colors.accent)
    }

    cssRule("&::after") {
        Modifier
            .position(Position.Absolute)
            .bottom((-2).px)
            .left(0.px)
            .height(2.px)
            .width(0.px)
            .backgroundColor(HLDITheme.Colors.primary)
    }

    cssRule("&:hover::after") {
        Modifier.width(100.percent)
    }
}